{
  "ariaLabel": "Varsler",
  "closeButtonAriaLabel": "Lukk varsel"
}
